import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SpinComponent } from './spin.component';

@NgModule({
  imports: [CommonModule],
  exports: [SpinComponent],
  declarations: [SpinComponent],
})
export class SpinModule {}
